import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#062e20] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-display font-semibold text-2xl uppercase tracking-tight">
            Catena<span className="text-[#ff4500]">Motosega.net</span>
          </div>
          <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-sm">
            Catene, barre guida e ricambi per motoseghe. Selezionati da chi il bosco lo vive ogni giorno.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">Catalogo</div>
          <div className="flex flex-col gap-2 text-sm">
            <Link to="/catalogo?categoria=Catene" className="text-white/70 hover:text-[#ff4500] transition-colors">Catene</Link>
            <Link to="/catalogo?categoria=Barre" className="text-white/70 hover:text-[#ff4500] transition-colors">Barre guida</Link>
            <Link to="/catalogo?categoria=Ricambi" className="text-white/70 hover:text-[#ff4500] transition-colors">Ricambi</Link>
            <Link to="/catalogo?categoria=Pompe%20Olio" className="text-white/70 hover:text-[#ff4500] transition-colors">Pompe olio</Link>
          </div>
        </div>
        <div className="md:col-span-4">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">Assistenza</div>
          <div className="flex flex-col gap-2 text-sm text-white/70">
            <span>Consegna in 24/48 ore lavorative; i tempi si possono allungare per Sud e Isole a causa della distanza geografica.</span>
            <span>Reso semplice entro 30 giorni</span>
            <span>Pagamenti sicuri con carte o contrassegno</span>
            <span className="font-mono text-xs mt-2">glamonica758@gmail.com</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
          <span>© 2026 CatenaMotosega.net — Tutti i diritti riservati</span>
          <span className="uppercase tracking-[0.2em]">Taglio perfetto. Potenza pura.</span>
        </div>
      </div>
    </footer>
  );
}
